// Page Notes — logout wipe of the agentation package's browser copies. The auth store imports this file at
// startup, so it must NOT import 'agentation' and must not name the toolbar settings key (that lives in
// toolbarSettings.ts, loaded only with the lazy toolbar chunk).
const NOTE_PREFIXES = ['feedback-annotations-', 'agentation-'];

export const safeStorage = (ls?: Storage): Storage | null => { try { return ls ?? window.localStorage; } catch { return null; } };
export function storageKeys(s: Storage): string[] { const out: string[] = []; for (let i = 0; i < s.length; i++) { const k = s.key(i); if (k) out.push(k); } return out; }

/** At logout: remove the package's local copies of notes (they can hold customer data). Returns how many keys went. */
export function clearPageNotesStorage(ls?: Storage): number {
  const s = safeStorage(ls); if (!s) return 0;
  let n = 0;
  try {
    for (const k of storageKeys(s)) if (NOTE_PREFIXES.some(p => k.startsWith(p))) { s.removeItem(k); n++; }
  } catch { /* storage blocked */ }
  return n;
}
